import './DashboardGrid.scss';

import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { readFiltered } from '../../redux/digiThemeReducer';
import { bindActionCreators as scopedBindActionCreators } from '../../utils/scopedReducer';

const mapDispatchToProps = dispatch => {
  return {
    loadDashboards: scopedBindActionCreators(readFiltered, dispatch, 'dashboards')
  };
};

const mapStateToProps = state => ({
  dashboards: state.dashboards.records,
  sessionToken: state.auth.sessionToken
});

class DashboardGridBase extends React.Component {

  static propTypes = {
    loadDashboards: PropTypes.func.isRequired,
    dashboards: PropTypes.array.isRequired,
    sessionToken: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
  };
  
  componentDidMount () {
    this.loadDashboards();
  }

  componentDidUpdate (prevProps) {
    if (prevProps.sessionToken !== this.props.sessionToken) {
      this.loadDashboards();
    }
  }

  loadDashboards () {
    this.props.loadDashboards(
      window.kyvDashboardConfig.dashboardsDt.columns,
      {
        sortColumns: [
          {
            name: 'title'
          }
        ]
      },
      '3857',
      0,
      0,
      null
    );
  }

  render () {
    const { dashboards, sessionToken } = this.props;

    return (
      <div className='dashboards--container'>
        {sessionToken && <h2>Tall og statistikk</h2>}
        <div className='dashboards--flex-container'>
          {dashboards &&
            dashboards.map(d => (
              <div key={`dashboard-${d.id}`} className='dashboards--article'>
                {d.media && (
                  <img
                    alt="Dashboard article"
                    src={`${
                      window.kyvDashboardConfig.adaptiveUrl
                    }WebServices/generic/Media.asmx/Download?uuid=${
                      d.media
                    }&thumbnail_size=small"/}`}
                  />
                )}
                <h3>{d.title}</h3>
                <div
                  className='dashboards--content'
                  dangerouslySetInnerHTML={{ __html: d.content.slice(0, 200) }}
                />
                <Link className='link-btn' to={`tallogstatistikk/${d.uri}/filter`}>
                  Vis
                </Link>
              </div>
            ))}
        </div>
      </div>
    );
  }
}

export const DashboardGrid = connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardGridBase);

export default DashboardGrid;


